"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainAdapterDisplayName = exports.ValidAddressResultType = exports.FeeDataKey = void 0;
const types_1 = require("@shapeshiftoss/types");
var FeeDataKey;
(function (FeeDataKey) {
    FeeDataKey["Slow"] = "slow";
    FeeDataKey["Average"] = "average";
    FeeDataKey["Fast"] = "fast";
})(FeeDataKey = exports.FeeDataKey || (exports.FeeDataKey = {}));
var ValidAddressResultType;
(function (ValidAddressResultType) {
    ValidAddressResultType["Valid"] = "valid";
    ValidAddressResultType["Invalid"] = "invalid";
})(ValidAddressResultType = exports.ValidAddressResultType || (exports.ValidAddressResultType = {}));
var ChainAdapterDisplayName;
(function (ChainAdapterDisplayName) {
    ChainAdapterDisplayName["Thorchain"] = "THORChain";
    ChainAdapterDisplayName["Osmosis"] = "Osmosis";
    ChainAdapterDisplayName["Ethereum"] = "Ethereum";
    ChainAdapterDisplayName["Avalanche"] = "Avalanche C-Chain";
    ChainAdapterDisplayName["Cosmos"] = "Cosmos";
    ChainAdapterDisplayName["Bitcoin"] = "Bitcoin";
    ChainAdapterDisplayName["BitcoinCash"] = "Bitcoin Cash";
    ChainAdapterDisplayName["Dogecoin"] = "Dogecoin";
    ChainAdapterDisplayName["Litecoin"] = "Litecoin";
})(ChainAdapterDisplayName = exports.ChainAdapterDisplayName || (exports.ChainAdapterDisplayName = {}));
